<template>
  <div
    v-if="shouldShowSessionRecording"
    :class="sessionId ? 'pag-session-recording-exhibition' : 'pag-session-recording pag-default-box'"
    id="pag-session-recording"
  >
    <div
    v-if="shouldShowSessionRecording"      
            class="pag-detail__presentation-player-box"
      :class="{ 'player-container-info-message': !user }"
    >
      <m-events-player
        :key="componentKey"
        :resource="videoResource"
        :autoplay="false"
        class="player"
        :new-player-id="newPlayerId"
        :session-id="sessionId"
      />
      <div v-if="!user" class="info-message-container">
        <h2>{{ $te("VMX.player_info_headline") ? $t("VMX.player_info_headline") : 'This content is available only to logged-in users'}}</h2>
        <p>{{ $te("VMX.player_info_subheadline") ? $t("VMX.player_info_subheadline") : 'Please log-in using the buttons below, or return to the previous page.' }}</p>
        <button
          v-if="!loginStatus"
          @click="login()"
          class="btn btn-primary"
        >
          {{ $t("VMX.user_login") }}
        </button>
        <button
          v-if="loginStatus"
          @click="logout"
          class="btn btn-primary"
        >
          {{ $t("VMX.user_logout") }}
        </button>
      </div>
    </div>
    <div
      v-else-if="hasAccess 
                 && sessionRecordingThumbnail
                 && initializedStatus 
                 && template.showSessionRecording
                 && componentVisibility('SessionRecording')"
    >
      <img
        class="pag-detail__presentation-player--preview-image"
        :src="sessionRecordingThumbnail"
      />
    </div>
  </div>
</template>


<script>
// TODO: remove this component at the end of the year, its in the vmx-components repo
import { mapGetters } from 'vuex'
import dayjs from 'dayjs'
import store from '~/store'
import mEventsPlayer from '../PresentationMEventsPlayer.vue'
import isBetween from 'dayjs/plugin/isBetween'
import pageStateMixins from '../../mixins/pageStateMixins'
import accessControl from '~/utilities/accessControl'
import visibilityMixins from '../../mixins/visibilityMixins'
import utils from '../../utilities'

dayjs.extend(isBetween)

export default {
  name: 'MEventsWebcastPlayer',
  inheritAttrs: false,
  mixins: [
    pageStateMixins,
    visibilityMixins,
  ],
  data() {
    return {
      videoResource: {},
      componentKey: 0,
      initialized: false,
    }
  },
  components: {
    mEventsPlayer,
  },
  props: {
    session: {
      type: Object,
      default: null,
    },
    sessionRecordingThumbnail: {
      type: String,
      default: '',
    },
    newPlayerId: {
      type: String,
      default: 'meventsPlayerElement',
    },
    sessionId: {
      type: String,
      default: '',
    },
  },
  methods: {
        // Insert timezone mixins here
    login() {
      if (this.$store.getters['instancesState/getInVMX']) {
          const destination = utils.getRouteWithDefaultParams('LoginPage', {}, { "returnUrl": localStorage.getItem("vmxReturnUrl")})
          const event = new CustomEvent('routerEvent', {
            detail: {
              message: 'rerouteParent',
              destination,
            },
          })
          window.dispatchEvent(event)

    } else {
      if(this.ssoBackendConfig?.SSOLogin) {
        this.SSOLogin(config.getInstanceConfig(this.instance), this.event, this.language, {}, this.$route, this.ssoBackendConfig)
      } else {
        this.navigateTo('AuthPage')
      }
    }
      
    },
    logout() {
      userState.unsetUser(this.instance)
      localStorage.setItem('userLoggedOut', true)

      if (this.ssoBackendConfig.defaults.externalAuth.logoutUrlPag) {
          const logoutUrlPag = this.ssoBackendConfig.defaults.externalAuth.logoutUrlPag
          // window.location.href = `${webFormsUrl + logoutUrl}?${queryStrings}`
          window.location.href = logoutUrlPag
          return
        }
      location.reload()
      return
    },
    navigateTo(name) {
      this.$router.push(utils.getRouteWithDefaultParams(name, {}, {}))
    },
    checkOndemandAvailability() {
      if (!this.session.OnDemandAvailability) {
        return false
      }

      const eventTimezone = utils.eventTimezone()
      const demandDate = dayjs.tz(this.session.OnDemandAvailability, eventTimezone)

      dayjs.tz.setDefault(eventTimezone)
      let serverTime = this.$store.getters['serverTime/getTime']
      const nowDate = dayjs.tz(dayjs(serverTime), eventTimezone)

      if (store.getters['instancesState/getSuperUser']) return true

      return nowDate.isAfter(demandDate)
    },
    checkEndDate() {
      if (!this.session.SessionRecordingVideoEndDateTime) return false
      const endDate = dayjs(this.session.SessionRecordingVideoEndDateTime.slice(0, 16))
      const eventTimezone = utils.eventTimezone()

      dayjs.tz.setDefault(eventTimezone)
      const serverTime = this.$store.getters['serverTime/getTime']
      const nowDate = dayjs.tz(dayjs(serverTime), eventTimezone)

      return nowDate.isAfter(dayjs.tz(endDate, eventTimezone))
    },
    checkStartDate() {
      if (!this.session.SessionRecordingVideoStartDateTime) return true
      const startDate = dayjs(this.session.SessionRecordingVideoStartDateTime.slice(0, 16))
      const eventTimezone = utils.eventTimezone()

      dayjs.tz.setDefault(eventTimezone)
      const serverTime = this.$store.getters['serverTime/getTime']
      const nowDate = dayjs.tz(dayjs(serverTime), eventTimezone)
      if (this.superUser) return true
      return nowDate.isAfter(dayjs.tz(startDate, eventTimezone))
    },
    checkStartDateUTC(params) {
      if (!params) return true
      const startDate = dayjs(params)
      const eventTimezone = utils.eventTimezone()
      const serverTime = this.$store.getters['serverTime/getTime']
      const nowDate = dayjs.tz(dayjs(serverTime), eventTimezone)
      dayjs.tz.setDefault(eventTimezone)

      if (this.superUser) return true
      return nowDate.isAfter(dayjs.tz(startDate, eventTimezone))
    },
    checkEndDateUTC(params) {
      if (!params) return false
      const endDate = dayjs(params)
      const eventTimezone = utils.eventTimezone()

      dayjs.tz.setDefault(eventTimezone)
      const serverTime = this.$store.getters['serverTime/getTime']
      const nowDate = dayjs.tz(dayjs(serverTime), eventTimezone)
      return nowDate.isAfter(dayjs.tz(endDate, eventTimezone))
    },
    checkBetweenDatesUTC(params1, params2) {
      if (!params1 || params2) return true
      const startDate = dayjs(params1)
      const endDate = dayjs(params2)

      const eventTimezone = utils.eventTimezone()

      dayjs.tz.setDefault(eventTimezone)
      const serverTime = this.$store.getters['serverTime/getTime']
      const nowDate = dayjs.tz(dayjs(serverTime), eventTimezone)
      if (this.superUser) return true
      return nowDate.isBetween(dayjs.tz(startDate, eventTimezone), dayjs.tz(endDate, eventTimezone))
    },
    checkBetweenDates() {
      if (!this.session.SessionRecordingVideoStartDateTime || !this.session.SessionRecordingVideoEndDateTime) return true
      const startDate = dayjs(this.session.SessionRecordingVideoStartDateTime.slice(0, 16))
      const endDate = dayjs(this.session.SessionRecordingVideoEndDateTime.slice(0, 16))

      const eventTimezone = utils.eventTimezone()
      const serverTime = this.$store.getters['serverTime/getTime']
      const nowDate = dayjs.tz(dayjs(serverTime), eventTimezone)
      dayjs.tz.setDefault(eventTimezone)

      if (this.superUser) return true
      return nowDate.isBetween(dayjs.tz(startDate, eventTimezone), dayjs.tz(endDate, eventTimezone))
    },
  },
  async mounted() {
    this.selectTemplateViaTime(this.session.SessionId, this.session.StartDateTime, this.session.EndDateTime)

    if(this.session.UseSessionRecordingV2 && this.session.SessionRecording) {
      if (!this.session.SessionRecording.IsHidden && (this.checkStartDateUTC(this.session.SessionRecording.AvailableFromUtc) || this.checkBetweenDatesUTC(this.session.SessionRecording.AvailableFromUtc, this.session.SessionRecording.AvailableUntilUtc))) {
        if (this.session.SessionRecording.CdnBaseUrl) {
          this.videoResource = {
            playerResource: {
              baseurl: this.session.SessionRecording.CdnBaseUrl+'/',
              id: this.session.SessionId,
              sessionRecording: true,
              sessionRecordingV2: this.session.UseSessionRecordingV2,
              session: this.session,
              signedUrl: this.webcastToken
            },
          }
          this.initialized = true
          if(this.session.UseSessionRecordingV2 && window?.mPlayer) window.mPlayer.jumpToSession()
        }
      }

      if (this.checkEndDateUTC(this.session.SessionRecording.AvailableUntilUtc)) {
        this.initialized = false
      }
    } else {
      if (this.checkStartDate() || this.checkBetweenDates()) {
        if (!this.session.HideSessionRecordingVideo && this.session.SessionRecordingFilePath) {
          this.videoResource = {
            playerResource: {
              baseurl: this.session.SessionRecordingFilePath,
              hide_pan_view: false,
              id: this.session.SessionId,
              show_thumbs: false,
              videoCrossDomain: false,
              mediatype_id: 1,
              resourcetype_id: 5,
              sessionRecording: true,
            },
          }
          this.initialized = true
        }
      }

      if (this.checkEndDate()) {
        this.initialized = false
      }
    }
  },
  computed: {
    ...mapGetters({
      configForKey: 'config/configForKey',
      eventId: 'instancesState/getEventId',
      superUser: 'instancesState/getSuperUser',
      webcastToken: 'user/getWebcastToken'
    }),
    hasAccess() {
      return this.newAccessControlViaSessionIds ? accessControl.accessControlSessionRecording(this.session.SessionId.toString()) : accessControl.accessControlKey('sessionRecording')
    },
    loginStatus() {
      return !!this.user
    },
    newAccessControlViaSessionIds() {
      const c = this.configForKey('app_config').configV2.defaultV2
      if ("newAccessControlViaSessionIds" in c) {
        return c.newAccessControlViaSessionIds 
      }
      return false
    },
    showLoginNoticeOnPlayer() {
      const c = this.configForKey('app_config').configV2.defaultV2
      if ("showLoginNoticeOnPlayer" in c) {
        return c.showLoginNoticeOnPlayer 
      }
      return false
    },
    shouldShowSessionRecording() {
      return this.hasAccess &&
             this.initializedStatus &&
             this.template.showSessionRecording &&
             ((this.session.UseSessionRecordingV2 && !this.session.SessionRecording.IsHidden) ||
              (!this.session.HideSessionRecordingVideo && this.session.SessionRecordingFilePath)) &&
             this.initialized &&
             this.checkOndemandAvailability() &&
             this.componentVisibility('SessionRecording');
    }
  },
}
</script>
<style lang="scss" scoped>
.pag-session-recording-exhibition {
  margin-bottom: 3rem;
}
.pag-session-recording{
  box-shadow: var(--pag-box-shadow);
  background: var(--pag-box-background);
  padding: var(--pag-box-padding);
  margin: var(--pag-box-margin);
  gap: var(--pag-box-gap);

  .pag-detail__presentation-player-box {
    position: relative;
    margin: 0 0 30px 0;
    padding: 0 0 30px 0;
  }

}
.pag-detail__presentation-player--preview-image {
    width: 100%;
  }

  .pag-detail__presentation-player-box.player-container-info-message .player {
  filter: blur(1rem);
  pointer-events: none;
}

.info-message-container {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 600px;
  max-width: 80%;
  background: #ffffff3e;
  padding: 1rem;
  border-radius: .25rem;
  border:1px solid var(--pag-primary);
  h2 {
      font-size: 1.5rem !important;
    }
}

</style>
